import React from 'react';
import { APP_NAME } from '../constants/app';
import { Redirect, Route } from 'react-router-dom';

export const isAuthorized = () => {
  let authToken = window.localStorage.getItem(`${APP_NAME}-authToken`);
  if (authToken !== null)
    if (authToken !== '') {
      return true;
    }
  return false;
};

export const PrivateRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => (isAuthorized() ? <Component {...props} /> : <Redirect to={`/login`} />)} />;

export const PublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (isAuthorized() ? props.location.pathname === rest.location.pathname ? <Redirect to={`/main`} /> : <Component {...props} /> : <Component {...props} />)} />
);
